export default __webpack_public_path__ + "static/media/new_dominion_angels.365c3103.png";